import { render, staticRenderFns } from "./CataModal.vue?vue&type=template&id=4e5aa938&scoped=true&"
import script from "./CataModal.vue?vue&type=script&lang=js&"
export * from "./CataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5aa938",
  null
  
)

export default component.exports